module.exports = __webpack_public_path__ + "media/images/action_show-8278f2424d7a6e08805e3023b28d8a13.png";